<script setup lang="ts">
import AgendaCalendar from "@/agenda/components/AgendaCalendar.vue";
</script>

<template>
  <div class="h-full p-6">
    <AgendaCalendar />
  </div>
</template>
